import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Button, Form, Icon, Input } from "semantic-ui-react";
import Erro from "../layouts/mensagens/Erro";
import * as FormValidator from "../../utils/formValidator";

const INTERVALO_REENVIO = 30;

// segundo fator do login: código enviado por e-mail (padrão) ou do aplicativo autenticador
const FormLogin2fa = ({ submit, onCancel, metodo, email, reenviar }) => {
  const porEmail = metodo === "email";
  const [codigo, setCodigo] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [segundos, setSegundos] = useState(porEmail ? INTERVALO_REENVIO : 0);
  const [reenviado, setReenviado] = useState(false);
  const [lembrar, setLembrar] = useState(false);
  const timer = useRef(null);

  const iniciarContagem = (inicio = INTERVALO_REENVIO) => {
    clearInterval(timer.current);
    setSegundos(inicio);
    timer.current = setInterval(() => {
      setSegundos(atual => {
        if (atual <= 1) clearInterval(timer.current);
        return Math.max(atual - 1, 0);
      });
    }, 1000);
  };

  useEffect(() => {
    if (porEmail) iniciarContagem();
    return () => clearInterval(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [porEmail]);

  const onSubmit = async e => {
    e.preventDefault();
    if (!codigo.trim()) {
      setErro("Informe o código");
      return;
    }
    setLoading(true);
    try {
      await submit(codigo.trim(), lembrar);
    } catch (err) {
      setErro(FormValidator.getErro(err));
      setCodigo("");
      setLoading(false);
    }
  };

  const onReenviar = async () => {
    setErro("");
    setLoading(true);
    try {
      await reenviar();
      setReenviado(true);
      setCodigo("");
      iniciarContagem();
    } catch (err) {
      setErro(FormValidator.getErro(err));
    }
    setLoading(false);
  };

  const onChangeCodigo = e => {
    setCodigo(porEmail ? e.target.value.replace(/\D/g, "") : e.target.value);
    setErro("");
  };

  const opcaoLembrar = (
    <label className="va-2fa-lembrar" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, margin: "6px 0", cursor: "pointer" }}>
      <input type="checkbox" checked={lembrar} onChange={e => setLembrar(e.target.checked)} />
      <span>Lembrar deste navegador por 7 dias</span>
    </label>
  );

  if (porEmail) {
    return (
      <Form onSubmit={onSubmit} loading={loading} size="large" className="va-cad-codigo">
        <div className="va-cad-icone"><Icon name="mail outline" /></div>
        <h3 className="va-cad-titulo">Confira seu e-mail</h3>
        <p className="va-cad-texto">
          Para sua segurança, enviamos um código de 6 dígitos para <b>{email}</b>.
          Digite-o abaixo para entrar.
        </p>
        <Erro tipo="block">{erro}</Erro>
        <Form.Field error={!!erro}>
          <input
            id="codigo2fa"
            name="codigo2fa"
            className="va-cad-codigo-input"
            inputMode="numeric"
            autoComplete="one-time-code"
            autoFocus
            maxLength={6}
            placeholder="••••••"
            aria-label="Código de 6 dígitos"
            value={codigo}
            onChange={onChangeCodigo}
          />
        </Form.Field>
        {opcaoLembrar}
        <Button icon labelPosition="right" type="submit" fluid className="btn-ui-1" size="large" style={{ margin: "10px 0" }}>
          Confirmar e entrar <Icon name="right chevron" />
        </Button>
        <div className="va-cad-links">
          {segundos > 0
            ? <span>{reenviado ? "Novo código enviado. " : ""}Reenviar código em {segundos}s</span>
            : <button type="button" className="va-cad-link" onClick={onReenviar}>Reenviar código</button>}
          <button type="button" className="va-cad-link" onClick={onCancel}>Voltar</button>
        </div>
        <p className="va-cad-dica">Não chegou? Veja a caixa de spam. O código vale por 10 minutos.</p>
      </Form>
    );
  }

  return (
    <Form onSubmit={onSubmit} loading={loading} size="large">
      <p style={{ textAlign: "center", fontSize: 13 }}>
        Digite o código de 6 dígitos do seu aplicativo autenticador
        (ou um código de recuperação).
      </p>
      <Erro tipo="block">{erro}</Erro>
      <Form.Field>
        <label htmlFor="codigo2fa">Código de verificação</label>
        <Input iconPosition="left">
          <Icon name="shield alternate" />
          <input
            id="codigo2fa"
            name="codigo2fa"
            inputMode="numeric"
            autoComplete="one-time-code"
            autoFocus
            maxLength={10}
            placeholder="000000"
            value={codigo}
            onChange={onChangeCodigo}
          />
        </Input>
      </Form.Field>
      {opcaoLembrar}
      <Button size="large" icon labelPosition="right" type="submit" fluid className="btn-ui-1" style={{ margin: "10px 0" }}>
        Verificar <Icon name="right chevron" />
      </Button>
      <div style={{ textAlign: "center", fontSize: 13, color: "#2185e0", cursor: "pointer" }} onClick={onCancel}>
        Voltar
      </div>
    </Form>
  );
};

FormLogin2fa.propTypes = {
  submit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  metodo: PropTypes.string,
  email: PropTypes.string,
  reenviar: PropTypes.func
};

FormLogin2fa.defaultProps = {
  metodo: "app",
  email: "",
  reenviar: () => Promise.resolve()
};

export default FormLogin2fa;
